// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel_container__37yad","slick-slide":"carousel_slick-slide__D6NjK"};